import request from 'assets/js/http';

export function documentTypeList() {
  // 文档类型列表
  return request({
    url: '/fileType/list',
    method: 'post'
  });
}
export function documentTypeAction(data) {
  // 新增-修改 项目文件类型
  let url = '/fileType/add';
  if (data.id || data.id === 0) {
    url = '/fileType/edit';
  }
  return request({
    url: url,
    method: 'post',
    data
  });
}
export function documentTypeShowOrHide(data) {
  // 启用-禁用 文档类型
  return request({
    url: `/${data.type}/${data.action}`,
    method: 'post',
    data: {
      id: data.id
    }
  });
}
// 文档管理
export function fileFoldersList() {
  // 文件夹列表
  return request({
    url: '/file/folders',
    method: 'post'
  });
}

export function fileList(data) {
  // 文件列表
  return request({
    url: '/file/list',
    method: 'post',
    data
  });
}

export function fileFoldersDelete(id) {
  // 文件夹删除
  return request({
    url: '/file/delete',
    method: 'post',
    data: {
      fileId: id
    }
  });
}
export function fileFoldersAdd(data) {
  // 文件夹 添加
  return request({
    url: '/file/mkFolder',
    method: 'post',
    data
  });
}
export function fileFoldersRename(data) {
  // 文件夹 重命名
  return request({
    url: '/file/rename',
    method: 'post',
    data
  });
}
export function fileFoldersDefaultPermission(data) {
  // 获取文件夹-默认权限
  return request({
    url: '/file/getPermissionUsers',
    method: 'post',
    data
  });
}

export function folderSetPermissionUsers(data) {
  // 获取文件夹-默认权限
  return request({
    url: '/file/setPermissionUsers',
    method: 'post',
    data
  });
}

export function editAuthType(data) {
  // 文件夹-保存权限(默认/自定义)
  return request({
    url: '/file/editAuthType',
    method: 'post',
    data
  });
}

// 专家访谈第一级文件夹列表
export function getExpertFolderList(data) {
  return request({
    url: '/file/getExpertDimensionList',
    method: 'post',
    data
  });
}

// 专家访谈第二级文件列表
export function getExpertFileList(data) {
  return request({
    url: 'file/getExpertList',
    method: 'post',
    data
  });
}

//打标签
export function addExpertTag(data) {
  return request({
    url: '/file/expertTag',
    method: 'post',
    data
  });
}

//新增模板
export function stencilAdd(data) {
  return request({
    url: '/gather/stencilAdd',
    method: 'post',
    data
  });
}

//查询模板
export function stencilQuery(data) {
  return request({
    url: '/gather/stencilQuery',
    method: 'post',
    data
  });
}

//查询portfolio
export function companyQuery(data) {
  return request({
    url: '/gather/companyQuery',
    method: 'post',
    data
  });
}
// 查询portfolio文件列表
export function getGatherList(data) {
  return request({
    url: '/gather/list',
    method: 'post',
    data
  });
}

//新增作业
export function taskAdd(data) {
  return request({
    url: '/gather/taskAdd',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data
  });
}

// ----- portfolio文件收集 ----- //

// 文件列表页

// 查询季度
export function quarterQuery(data) {
  return request({
    url: '/gather/quarterQuery',
    method: 'post',
    data
  });
}

// 查询作业
export function taskQuery(data) {
  return request({
    url: '/gather/taskQuery',
    method: 'post',
    data
  });
}

export function queryInvestFundList(searchName) {
  return request({
    url: '/finance/queryInvestFundList',
    method: 'post',
    data: {
      searchName: searchName
    }
  });
}

// 新增评论
export function commentAdd(data) {
  return request({
    url: '/gather/commentAdd',
    method: 'post',
    data
  });
}

// 编辑作业说明
export function descriptionModify(data) {
  return request({
    url: '/gather/descriptionModify',
    method: 'post',
    data
  });
}

// 编辑项目人员关系
export function editPortfolioMember(data) {
  return request({
    url: '/gather/editPortfolioMember',
    method: 'post',
    data
  });
}

// 获取项目人员关系
export function getPortfolioMember(data) {
  return request({
    url: '/gather/getPortfolioMember',
    method: 'post',
    data
  });
}

// 文件下载
export function fileDownload(data) {
  return request({
    url: '/gather/fileDownload',
    method: 'post',
    data
  });
}

export function fileDownloadZip(data) {
  return request({
    url: '/gather/fileDownloadZip',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    timeout: 100000,
    data
  });
}

// 文件预览
export function fileView(data) {
  return request({
    url: '/gather/fileView',
    method: 'post',
    data
  });
}

//查询筛选条件及文件夹(filling)
export function queryTerm(data) {
  return request({
    url: '/filing/queryTerm',
    method: 'post',
    // headers: {
    //   'content-type': 'application/json'
    // },
    data
  });
}

//查询文件(filling)
export function queryFiles(data) {
  return request({
    url: '/filing/queryFile',
    method: 'post',
    data
  });
}

//编辑原件编码(filling)
export function editOriginalCode(data) {
  return request({
    url: '/filing/editOriginalCode',
    method: 'post',
    data
  });
}

//文件下载(filling)
export function downloadZip(data) {
  return request({
    url: '/filing/downloadZip',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    timeout: 100000,
    data
  });
}

//文件子类型添加
export function addSubFile(data) {
  return request({
    url: '/fileSubType/add',
    method: 'post',
    data
  });
}

//文件子类型编辑
export function editSubFile(data) {
  return request({
    url: '/fileSubType/edit',
    method: 'post',
    data
  });
}

//可上传文档类型
export function uploadSelectList(data) {
  return request({
    url: '/fileType/uploadSelectList',
    method: 'post',
    data
  });
}

//项目文件轮次信息
export function companyFileRoundInfo(data) {
  return request({
    url: '/companyFile/roundInfo',
    method: 'post',
    data
  });
}

//文档轮次修改
export function roundChange(data) {
  return request({
    url: '/companyFile/roundChange',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data
  });
}

//代传作业删除
export function proxyDeleteCompanyFile(data) {
  return request({
    url: '/gather/proxyDeleteCompanyFile',
    method: 'post',
    data
  });
}
export const taskQueryByCompanyId = data => {
  return request({
    url: '/gather/taskQueryByCompanyId',
    method: 'post',
    data: data
  });
};

//查询项目名在天池是否存在
export function checkCompanyExist(data) {
  return request({
    url: '/company/checkCompanyExist',
    method: 'post',
    params: data
  });
}

// ----- portfolio Review----- //
export function queryQuarter(data) {
  return request({
    url: '/portfolioReview/queryQuarter',
    method: 'post',
    data
  });
}

// 查询portfolio Review 文件 list
export function portfolioReviewList(data) {
  return request({
    url: '/portfolioReview/list',
    method: 'post',
    data
  });
}

// 创建portfolio Review 文件整理任务
export function createTask(data) {
  return request({
    url: '/portfolioReview/createTask',
    method: 'post',
    data
  });
}

// 查询portfolio Review 文件整理任务
export function queryTask(data) {
  return request({
    url: '/portfolioReview/queryTask',
    method: 'post',
    data
  });
}

// 查询portfolio Review 解析财务文件
export function getFinanceInfo(data) {
  return request({
    url: '/gather/getFinanceInfo',
    method: 'post',
    data
  });
}


export function getAiSummaryByFinanceInfo(data) {
  return request({
    url: '/gather/getAiSummaryByFinanceInfo',
    method: 'post',
    timeout: 100000,
    data
  });
}

export function showChartLog(data) {
  return request({
    url: '/gather/showChartLog',
    method: 'post',
    data
  });
}
